// components/ChatInput.js
import { Play } from 'lucide-react';
import React, { useState } from 'react';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled: boolean;
}

export const ChatInput = ({ onSend, disabled }: ChatInputProps) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (message.trim()) {
      onSend(message);
      setMessage('');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleSubmit(e);
        }
      }}
      className="m-4 rounded-lg"
    >
      <div className="flex space-x-2 bg-background-card p-2 rounded-lg h-[70px]">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Chat with Kreaitor"
          disabled={disabled}
          className="flex-1 bg-background text-text-primary  resize-none  focus:outline-none rounded-lg focus:ring-0 border-0"
        />
        <button
          type="submit"
          disabled={disabled || !message.trim()}
          className="px-4  py-2 bg-background-main text-primary rounded-lg disabled:bg-neutral"
        >
          <Play />
        </button>
      </div>
    </form>
  );
};

export default ChatInput;
